import React, { useEffect, useState, useRef } from 'react'
import { getData, postData } from '../../../../actions/servicesHttp'
import PropTypes from 'prop-types'
import styles from '../../../../css/RxartSecure/ActionsRS.module.css'
import { Message } from 'primereact/message'
import Mapa from '../../../generals/map'
import { formatDate } from '../../../generals/charts/utils/DatesFormats'
import stylesLocation from '../../../../css/RxartSecure/LastLocationRS.module.css'
import $ from 'jquery'
import store from '../../../../reducer/store'
import { showPopup } from '../../../Popups/SweetAlertPopups'
import { ProgressSpinner } from 'primereact/progressspinner'
import { Toast } from 'primereact/toast'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ActionsRS ({ data, actions, setActions, device, modalsShow, setModalsShow, close }) {
  // console.log(device, 'linea 12')
  const { t } = useTranslation('dashboardDevice')
  const { user } = store.getState()
  const navigate = useNavigate()
  const toast = useRef(null)
  // ? urls de la API cuco
  const [rxartSecureTicketUnlockUrl] = useState('rxartsecure/query_calc_unlock_code')
  const [locationsUrl] = useState('device/last_location')
  const [changeRxDeviceData] = useState('rxartsecure/change_device_data')
  const [locations, setLocations] = useState()
  const [label, setLabel] = useState('')

  // // Estados para mostrar o no los modales
  const [components, setComponents] = useState({
    changeStatusComponent: false,
    unlockCodeComponent: false,
    lastLocation: false
  })

  const [unlockCode, setUnlockCode] = useState({
    seedCode: '',
    license: device?.device?.license ? device?.device?.license : t('modalRxartSecure.label3'),
    deviceId: device?.device?.deviceId
  })

  const [actionsRS, setActionsRS] = useState({
    statusId: 'U',
    statusName: 'Unknown'
  })

  const [loading, setLoading] = useState(false)

  const deviceStatusOptions = [
    { name: 'noChangeDevice', statusId: 'U', statusName: 'Unknown', label: t('modalRxartSecure.label34') },
    { name: 'enabledDevice', statusId: 'AC', statusName: 'Active', label: t('modalRxartSecure.label35') },
    { name: 'lockDevice', statusId: 'BL', statusName: 'Locked', label: t('modalRxartSecure.label36') },
    { name: 'unlockDevice', statusId: 'FR', statusName: 'Free', label: t('modalRxartSecure.label37') }
  ]

  const getLocation = async (url, data, set) => {
    const response = await getData(url, data, navigate)
    // console.log(response, url)
    if (response?.status === 200) {
      set(response.data)
    } else {
      set({ error: true, code: response?.code })
    }
  }

  const validationsInputs = () => {
    let response = true

    const seedCode = document.getElementById('inputSeedCode')
    $('#codeUnlock').addClass(`${styles.visible}`)

    if (seedCode?.value === '') {
      $('#inputSeedCode').addClass(`${styles.error}`)
      $('#errorLog').text(t('modalRxartSecure.label62'))
      response = false
    }

    if (response) {
      $('#inputSeedCode').removeClass(`${styles.error}`)
      $('#errorLog').text('')
    }
    return response
  }

  //* llamados de la API cuco
  const calculateUnlockCode = async () => {
    $('#btnUnlockCode').prop('disabled', true)
    setLoading(true)
    $('#errorLog').text('')
    $('#ticketCodeUnlock').text('')
    $('#containerCodeUnlock').removeClass(`${styles.visible}`)

    const validation = validationsInputs()
    if (validation) {
      const body = { deviceId: unlockCode?.deviceId, code: unlockCode?.seedCode.replace(/ /g, ''), userId: user?.userId }
      const response = await postData(rxartSecureTicketUnlockUrl, body, navigate)
      if (response.status === 200) {
        $('#ticketCodeUnlock').text(response.data.code)
        $('#containerCodeUnlock').addClass(`${styles.visible}`)
      } else {
        $('#errorLog').text(t('modalRxartSecure.label63'))
        console.log({ error: true, response })
      }
    }
    setLoading(false)
    $('#btnUnlockCode').prop('disabled', false)
  }

  const handleInputRadio = (e) => {
    // console.log(e.target.name, e.target.value)
    const statusId = JSON?.parse(e.target.value).statusId
    const statusName = JSON?.parse(e.target.value).statusName
    setActionsRS({
      statusId,
      statusName
    })
    setLabel(statusId === 'BL' ? 'bloquear' : statusId === 'AC' ? 'activar' : statusId === 'FR' ? 'liberar' : '')
  }

  const handleInputChange = (e) => {
    // console.log(e.target.name, e.target.value)
    setUnlockCode({
      ...unlockCode,
      [e.target.name]: e.target.value
    })
  }

  const changeDeviceStatus = async (device, url) => {
    const body = {
      deviceId: device.device.deviceId,
      serialBios: device.device.serialBios,
      statusId: actionsRS.statusId,
      statusName: actionsRS.statusName
    }

    const response = await postData(`${url}/${device?.device?.deviceId}`, body, navigate)
    if (response.status === 200) {
      showPopup('success', t('modalRxartSecure.label64'))
      close()
    } else {
      showPopup('error', t('modalRxartSecure.label65'))
      console.error({ error: true, code: response.code })
    }
  }

  const copyCode = async () => {
    const code = document.getElementById('ticketCodeUnlock').textContent
    try {
      await navigator.clipboard.writeText(code)
      toast.current.show({
        severity: 'info',
        summary: '',
        detail: t('modalRxartSecure.label66'),
        life: 3000
      })
    } catch (err) {
      toast.current.show({
        severity: 'error',
        summary: '',
        detail: t('modalRxartSecure.label67'),
        life: 3000
      })
      console.error('Error al copiar:', err)
    }
  }

  useEffect(() => {
    if (data) {
      setComponents({
        changeStatusComponent: false,
        unlockCodeComponent: false,
        lastLocation: false
      })
    }
  }, [data])

  useEffect(() => {
    if (device) {
      setActionsRS({
        statusId: device?.device?.statusId,
        statusName: device?.device?.statusName
      })
      setLabel(device?.device?.statusId === 'BL' ? 'bloquear' : device?.device?.statusId === 'AC' ? 'activar' : device?.device?.statusId === 'FR' ? 'liberar' : '')
    }
  }, [device])

  useEffect(() => {
    setUnlockCode({
      seedCode: '',
      license: device?.device?.license ? device?.device?.license : 'No Disponible',
      deviceId: device?.device?.deviceId
    })
  }, [components])

  useEffect(() => {
    if (data) {
      getLocation(locationsUrl, data?.id, setLocations)
    }
  }, [locationsUrl, data])

  return (
    <div className={styles.actionsContainer}>
      {!components?.lastLocation && <div className={styles.buttonsContainer}>
        <button className={styles.buttonsRS} onClick={() => setComponents({ changeStatusComponent: true, lastLocation: false, unlockCodeComponent: false })} disabled={device?.device?.license === 'No disponible'}>
          <i className={`pi pi-arrow-right ${styles.iconBtn}`}></i>
          <span>{t('modalRxartSecure.button6')}</span>
        </button>
        <button className={styles.buttonsRS} onClick={() => setComponents({ changeStatusComponent: false, unlockCodeComponent: true, lastLocation: false })} disabled={device?.device?.license === 'No disponible'}>
          <i className={`pi pi-lock-open ${styles.iconBtn}`}></i>
          <span>{t('modalRxartSecure.button7')}</span>
        </button>
      </div>}
      {components?.changeStatusComponent && <div className={styles.deviceStatusOptionsContainer}>
                  <span className={styles.spanState}>{t('modalRxartSecure.label68')}</span>
                  <div className={styles.statusContainer}>
                    <div className={styles.statusListContainer}>
                      {
                        deviceStatusOptions?.map((option) => {
                          return (
                              <div key={option.name} >
                                <input
                                  type='radio'
                                  id={option.name}
                                  name={option.name}
                                  value={JSON.stringify({ statusId: option.statusId, statusName: option.statusName })}
                                  onChange={(e) => handleInputRadio(e)}
                                  checked={option.statusId === actionsRS.statusId}
                                  disabled={(device?.device?.license === 'No disponible') || (option.statusId === 'U')}
                                  className={styles.check}
                                />
                                <label htmlFor={option.name} className={styles.labelDeviceStatusOptions}>{option.label}</label>
                              </div>
                          )
                        })
                      }
                    </div>
                    <button className={`${styles.btnCode} ${styles.btnChangeStatus}`}
                      onClick={() => setComponents({
                        ...components,
                        changeStatusComponent: false,
                        lastLocation: true
                      })}>
                      <i className={`pi pi-sync ${styles.iconBtnCode}`}></i>
                      <span className={styles.spanBtnCode}>{t('modalRxartSecure.button8')}</span>
                    </button>
                  </div>
      </div>}
       {components?.unlockCodeComponent && <div className={styles.unlockCodeComponent}>
              <div className={styles.inputContainer}>
                <label>{t('modalRxartSecure.label22')}</label>
                <input value={unlockCode.license} name="license" id='inputLicense' type="text" disabled={true} />
              </div>
              <div className={styles.inputContainer}>
                <label>{t('modalRxartSecure.label23')}</label>
                <input value={unlockCode.deviceId} name="deviceId" id='inputdeviceId' type="text" disabled={true} />
              </div>
              <div className={styles.inputContainer}>
                <label className={styles.colorLabel}>{t('modalRxartSecure.label46')}</label>
                <div className={styles.doubleInput}>
                  <input className={`${styles.input} ${styles.inputBtn} ${styles.colorInputBtn}`} value={unlockCode.seedCode} name='seedCode' id='inputSeedCode' type="text" onChange={(e) => handleInputChange(e)} placeholder='...'/>
                  <button className={styles.btnCode} onClick={() => calculateUnlockCode()} id="btnUnlockCode">
                    <i className={`pi pi-sync ${styles.iconBtnCode}`}></i>
                    <span className={styles.spanBtnCode}>{t('modalRxartSecure.button9')}</span>
                  </button>
                </div>
              </div>
              <Toast ref={toast} />
        <div className={styles.code} id='codeUnlock'>
          <span className={styles.labelCodeUnlock}>{t('modalRxartSecure.label69')}</span>
          <div className={styles.containerCodeUnlock} id='containerCodeUnlock'>
            <span id="ticketCodeUnlock" className={`prueba ${styles.codeUnlock}`}></span>
            <button className={styles.btnCopy} onClick={() => copyCode()} id="copyBtn">
              <i className={`pi pi-copy ${styles.iconBtnCopy}`}></i>
            </button>
          </div>
          {loading && <ProgressSpinner style={{ width: '2.5rem', height: '2.5rem' }} strokeWidth="5" />}
          <span className={styles.errorLog} id='errorLog'></span>
        </div>
      </div>}
      {components?.lastLocation && <div className={stylesLocation.lastLocationContainer}>
          <div className={stylesLocation.container}>
            <button className={stylesLocation.btn} onClick={() => {
              setActionsRS({
                statusId: device?.device?.statusId,
                statusName: device?.device?.statusName
              })
              setComponents({ changeStatusComponent: false, lastLocation: false, unlockCodeComponent: false })
              setLabel(device?.device?.statusId === 'BL' ? t('modalRxartSecure.label55') : device?.device?.statusId === 'AC' ? t('modalRxartSecure.label56') : device?.device?.statusId === 'FR' ? t('modalRxartSecure.label57') : '')
            }}>
              <i className={`pi pi-arrow-left ${styles.iconBtn}`}></i>
            </button>
            <Message
              style={{
                /* border: 'solid #696cff', */
                /* borderWidth: '1px 1px 1px 0.5rem', */
                /* backgroundColor: 'white', */
                fontWeight: '600',
                padding: '0.4rem 1rem'
              }}
              severity="info"
              text={`${t('modalRxartSecure.label58')} ${label} ${t('modalRxartSecure.label59')}`}
            />
          </div>
          <div className={stylesLocation.dataLocationContainer}>
              <div className={stylesLocation.dataDevice}>
                <p><span className={stylesLocation.bold}>{t('modalRxartSecure.label21')}:</span> {device?.device?.serialBios ? device?.device?.serialBios : 'No disponible'} </p>
                <p><span className={stylesLocation.bold}>{t('modalRxartSecure.label22')}:</span> {device?.device?.license ? device?.device?.license : 'No disponible'}</p>
                <p><span className={stylesLocation.bold}>{t('modalRxartSecure.label23')}:</span> {device?.device?.deviceId ? device?.device?.deviceId : 'No disponible'}</p>
                <p><span className={stylesLocation.bold}>{t('modalRxartSecure.label60')}:</span>{locations?.last_location?.date ? ` ${formatDate(locations?.last_location?.date)} ` : ' No disponible '}</p>
              </div>
              <button className={`${styles.btnCode} ${styles.btnChangeStatus}`}
                onClick={() => changeDeviceStatus(device, changeRxDeviceData)}>
                <i className={`pi pi-thumbs-up ${styles.iconBtnCode}`}></i>
                <span className={styles.spanBtnCode}>{t('modalRxartSecure.button10')}</span>
              </button>
          </div>
          <Mapa
            info={locations?.last_location}
            type="last"
          />
      </div>}
    </div>
  )
}

ActionsRS.propTypes = {
  actions: PropTypes.object,
  setActions: PropTypes.func,
  data: PropTypes.object,
  device: PropTypes.object,
  modalsShow: PropTypes.object,
  setModalsShow: PropTypes.func,
  close: PropTypes.func
}
